import AmlHighRisk from './AmlHighRisk';

export default AmlHighRisk;
